// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"158":"52d4cc7b","324":"52d4cc7b"}[chunkId] + ".chunk.css";
};